import type { RouteObject } from 'react-router';

import { userDetailRoute } from './detail/users-detail.route';
import { usersRoute } from './index/users.route';

/**
 * The account area's two routes, aggregated.
 *
 * The feature backs two routes, so it takes the multi-route shape: one folder
 * per route plus `_shared/` for what both need, and this file is the plural
 * `.routes.tsx` the composition root imports as an array. The register and the
 * detail are siblings rather than parent and child — the detail is not rendered
 * inside the register, and neither route is a layout for the other.
 *
 * The pack's `users/` bucket is a **file-organisation** name and never reaches
 * the URL: the routes are `/users` and `/users/:userId`, and no bucket segment
 * appears in either.
 */
export const usersRoutes: RouteObject[] = [usersRoute, userDetailRoute];
